import type { Language } from '@seek/ca-myprofile-utils';
import { ResumeSensitiveDialog } from '@seek/profile-base-ui';
import { useState } from 'react';

import { useAnalytics } from 'src/modules/analytics/AnalyticsProvider';
import { useAppConfig } from 'src/modules/appConfig';

export const useSensitivePrivacyDialog = () => {
  const [showDialog, setShowDialog] = useState(false);
  const { zone, language } = useAppConfig();

  const { resumeSensitiveInfoDialogPressed } = useAnalytics();
  const onTrackSensitiveInfoLink = () => {
    resumeSensitiveInfoDialogPressed({
      eventName: 'sensitive_information_dialog_pressed',
      linkText: 'Sensitive information: what you need to know',
    });
  };

  const dialogProps = {
    open: showDialog,
    onClose: () => setShowDialog(false),
    onTrackSensitiveInfoLink,
    zone,
    language: language as Language,
  };

  return {
    dialog: <ResumeSensitiveDialog {...dialogProps} />,
    setShowDialog,
  };
};
